import React, { Component } from "react";

import { defined } from "@formant/core/common/defined";
import { IModule } from "@formant/core/model/IModule";

import { appStore, customModuleStore } from "../../../stores";
import { Buttons } from "../../common/Buttons";
import { ActionButton } from "../ActionButton";

export interface IActionsProps {
    customModule: IModule;
}

export class Actions extends Component<IActionsProps> {
    public render() {
        return (
            <Buttons>
                <ActionButton
                    icon="delete"
                    onClicked={this.onDelete}
                    data-tooltip="Remove custom module"
                />
            </Buttons>
        );
    }

    private onDelete = () => {
        const { customModule } = this.props;
        const { name, id } = customModule;
        appStore.setConfirm({
            title: "Delete Custom Module",
            message: `Delete custom module "${name}"?`,
            onOk: async () => {
                await customModuleStore.delete(defined(id));
                appStore.setSnackbar("Custom module deleted");
            },
        });
    };
}
